/* LOG */
export const GET_LOG = "GET_LOG"
export const GET_LOG_SUCCESS = "GET_LOG_SUCCESS"
export const GET_LOG_FAIL = "GET_LOG_FAIL"

